module.exports = __webpack_public_path__ + "static/media/Poppins-Bold-devanagari.7def222d.woff2";